import { FetchBuilderOptions, FetchFnArgs } from '../types/apiTypes';

const buildRequestParams = ({
  access_token,
  baseUrl,
  signal,
}: FetchFnArgs): {
  BASE_URL: string;
  options: { Authorization: string; signal?: AbortSignal };
} => {
  return {
    BASE_URL: baseUrl,
    options: {
      Authorization: access_token ?? '',
      signal,
    },
  };
};

export const buildFetchParams = ({
  signal,
  baseUrl,
  access_token,
}: FetchFnArgs): { BASE_URL: string; options: RequestInit } => ({
  BASE_URL: baseUrl,
  options: {
    method: 'GET',
    headers: {
      Authorization: access_token ?? '',
    },
    signal,
  },
});

export const buildCreateParams = <TBody>(
  args: FetchFnArgs<{ body: TBody }>
): FetchBuilderOptions => {
  const {
    BASE_URL,
    options: { Authorization, signal },
  } = buildRequestParams(args);

  return {
    BASE_URL,
    options: {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        Authorization,
      },
      body: JSON.stringify(args.body),
      signal,
    },
  };
};

export const buildUpdateParams = <TBody>(
  args: FetchFnArgs<{ body: TBody }>
): FetchBuilderOptions => {
  const {
    BASE_URL,
    options: { Authorization, signal },
  } = buildRequestParams(args);

  return {
    BASE_URL,
    options: {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        Authorization,
      },
      body: JSON.stringify(args.body),
      signal,
    },
  };
};

export const buildDeleteParams = (args: FetchFnArgs): FetchBuilderOptions => {
  const {
    BASE_URL,
    options: { Authorization, signal },
  } = buildRequestParams(args);

  return {
    BASE_URL,
    options: {
      method: 'DELETE',
      headers: {
        Authorization,
      },
      signal,
    },
  };
};
